module.exports = __webpack_public_path__ + "dist/img/erp.de913199.webp";